import { TransactionReports } from "../../../shared/components/transaction-reports/transaction-reports";

export function BackofficeTransactionReports() {
  return <TransactionReports />;
}
